import React from "react";
import styles from "./select.css"
let PropTypes = React.PropTypes;
// API
import api from "../../../apiClient/v1";
// CSS
import * as css from "../modal.css";
// Componentes
import { AutoSizer, Table, Column } from "react-virtualized";

export class DetalleProgramacionIG extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      idCliente: "0",
      cutRegion: [{
        cutRegion: "0",
        nombreCorto: 'Todas'
      }],
      clientes: this.props.clientes,
      regiones: this.props.regiones,
      fechaInicio: this.props.fechaInicio,
      fechaFin: this.props.fechaFin,
      detalle: [],
      dividir: false,
      show: false,
      highlightedIndex: 0
    };
    this.fetchDetalle = () => {
      const regiones = this.state.cutRegion.map(item => item.cutRegion).join('-')
      api.inventario
        .getDetalle(
          this.state.fechaInicio,
          this.state.fechaFin,
          this.state.idCliente,
          regiones
        )
        .then((detalle) => {
          this.setState({
            detalle: detalle.datos,
          });
        })
        .catch((meh) => { });
    };
    this.seleccionarRegion = (option) => {
      const opcion = {
        cutRegion: option.cutRegion,
        nombreCorto: option.nombreCorto
      }

      const index = this.state.cutRegion.findIndex(
        (o) => o.cutRegion === opcion.cutRegion
      );

      if (index !== -1) {
        const newState = this.state.cutRegion.slice();
        newState.splice(index, 1);

        if (newState.length > 0) {
          this.setState(
            {
              cutRegion: newState,
              detalle: [],
            },
            () => {
              this.fetchDetalle();
            }
          );
        } else {
          this.setState(
            {
              cutRegion: [{
                cutRegion: "0",
                nombreCorto: 'Todas'
              }],
              detalle: [],
            },
            () => {
              this.fetchDetalle();
            }
          );
        }
      } else {
        const estado = this.state.cutRegion.filter(c => (c.cutRegion !== "0"))
        const array = {
          cutRegion: option.cutRegion,
          nombreCorto: option.nombreCorto
        };
        estado.push(array)
        this.setState(
          {
            cutRegion: estado,
            detalle: [],
          },
          () => {
            this.fetchDetalle();
          }
        );
      }
    };
    this.seleccionarCliente = (evt) => {
      const idCliente = evt.target.value;
      this.setState(
        {
          idCliente: idCliente,
          detalle: [],
        },
        () => {
          this.fetchDetalle();
        }
      );
    };
    this.handleShow = () => {
      this.setState({
        show: !this.state.show
      })
    };
    this.handleShowBlur = () => {
      this.setState({
        show: false
      })
    }
    this.clearOptions = (e) => {
      e.stopPropagation()
      this.setState({
        cutRegion: [{
          cutRegion: "0",
          nombreCorto: 'Todas'
        }]
      },
        () => {
          this.fetchDetalle();
        })
    }
    this.isSelected = (option) => {
      const op = {
        cutRegion: option.cutRegion,
        nombreCorto: option.nombreCorto
      }
      return this.state.cutRegion.some((item) => {
        return item.cutRegion === op.cutRegion;
      });
    }
  }
  renderDivisionTablas() {
    return (
      <div className="row">
        <div className="col-md-6">
          <Detalle detalle={this.state.coleccionUno} />
        </div>
        <div className="col-md-6">
          <Detalle detalle={this.state.coleccionDos} />
        </div>
      </div>
    );
  }
  renderTablaNormal() {
    return (
      <div className="row">
        <div className="col-md-6">
          <Detalle detalle={this.state.detalle} />
        </div>
        <div className="col-md-1">
          <table style={{ width: "100%" }}>
            <thead>
              {this.state.detalle.length > 0 && this.state.cutRegion[0].cutRegion != "0" ?
                <tr style={{ justifyContent: "center", textAlign: 'center', height: '30px' }}>
                </tr> :
                null}
            </thead>
            <tbody>
              {this.state.detalle.length > 0 && this.state.cutRegion[0].cutRegion != 0 ?
                this.state.detalle.map((d, index) => (
                  <tr className={index % 2 === 0 ? css.evenRow : css.oddRow} key={index}>
                    <td style={{ height: "40px", textAlign: "center" }}>
                      <div className={styles.tooltipInicio}>
                        <span style={{ marginTop: '10px' }} className="glyphicon glyphicon-info-sign"></span>
                        <span className={styles.tooltiptextInicio}>
                          <p style={{ textAlign: "left" }}>
                            {d.fechaFormat == 'PROMEDIOS' ? 
                            "Resumen Promedios:" : d.fechaFormat == "TOTALES" ? 
                            "Resumen Totales:" : "Resumen Diario:"}
                            </p>
                          {d.info.length > 1 ? d.info.map((a, index) => (
                            <div style={{ padding: "5px" }}>
                              <p style={{ textAlign: "left" }} key={index}>{a}</p>
                            </div>
                          )) : <p style={{ textAlign: "left", padding: "5px" }}>{d.info}</p>}
                        </span>
                      </div>
                    </td>
                  </tr>
                )) : null}
            </tbody>
          </table>
        </div>
      </div >
    );
  }
  componentWillMount() {
    this.fetchDetalle();
  }
  render() {
    return (
      <div className="container-fluid">
        <div className="row">
          <SelectorCliente
            idClienteSeleccionado={this.state.idCliente}
            seleccionarCliente={this.seleccionarCliente}
            clientes={this.state.clientes}
          />
          <SelectorRegion
            idRegionSeleccionada={this.state.cutRegion}
            seleccionarRegion={this.seleccionarRegion.bind(this)}
            regiones={this.state.regiones}
            show={this.state.show}
            handleShow={this.handleShow}
            handleShowBlur={this.handleShowBlur.bind(this)}
            clearOptions={this.clearOptions.bind(this)}
            highlightedIndex={this.state.highlightedIndex}
            isSelected={this.isSelected.bind(this)}
          />
        </div>
        {this.state.dividir
          ? this.renderDivisionTablas()
          : this.renderTablaNormal()}
      </div>
    );
  }
}
const Detalle = ({ detalle }) => (
  <div style={{ height: "100%" }} className="row">
    <AutoSizer>
      {({ height, width }) => (
        <Table
          // general
          height={height}
          width={width}
          // headers
          headerHeight={30}
          headerClassName={css.headerColumn}
          // rows
          rowCount={detalle.length}
          rowGetter={({ index }) => detalle[index]}
          rowHeight={40}
          rowClassName={({ index }) =>
            index < 0
              ? css.headerRow
              : index % 2 === 0
                ? css.evenRow
                : css.oddRow
          }
        >
          {/* FECHAS */}
          <Column
            dataKey="fechaFormat"
            label="Fechas"
            cellRenderer={({
              cellData,
              columnData,
              dataKey,
              rowData,
              rowIndex,
            }) => rowData[dataKey]}
            width={145}
          />
          {/* TOTAL INVENTARIOS */}
          <Column
            dataKey="totalIG"
            label="Total IG"
            cellRenderer={({
              cellData,
              columnData,
              dataKey,
              rowData,
              rowIndex,
            }) => rowData[dataKey]}
            width={70}
          />
          {/* TOTAL INVENTARIOS NOCHE */}
          <Column
            dataKey="totalIGnoche"
            label="IG Noche"
            cellRenderer={({
              cellData,
              columnData,
              dataKey,
              rowData,
              rowIndex,
            }) => rowData[dataKey]}
            width={80}
          />
          {/* TOTAL INVENTARIOS DIA*/}
          <Column
            dataKey="totalIGdia"
            label="IG Día"
            cellRenderer={({
              cellData,
              columnData,
              dataKey,
              rowData,
              rowIndex,
            }) => rowData[dataKey]}
            width={80}
          />
          {/* TOTAL OPERADORES NOCHE*/}
          <Column
            dataKey="operadoresNoche"
            label="Operadores Noche"
            cellRenderer={({
              cellData,
              columnData,
              dataKey,
              rowData,
              rowIndex,
            }) => rowData[dataKey]}
            width={140}
          />
          {/* TOTAL OPERADORES DIA*/}
          <Column
            dataKey="operadoresDia"
            label="Operadores Día"
            cellRenderer={({
              cellData,
              columnData,
              dataKey,
              rowData,
              rowIndex,
            }) => rowData[dataKey]}
            width={120}
          />
        </Table>
      )}
    </AutoSizer>
  </div>
);

const SelectorCliente = ({
  idClienteSeleccionado,
  seleccionarCliente,
  clientes,
}) => (
  <div className="col-sm-2 form-group ">
    <label className="control-label" htmlFor="cliente">
      Clientes
    </label>
    <select
      className="form-control"
      name="clientes"
      value={idClienteSeleccionado}
      onChange={seleccionarCliente}
    >
      <option value="0">Todas</option>
      {clientes.map((cliente) => (
        <option
          key={cliente.idCliente}
          value={cliente.idCliente}
        >{`${cliente.nombreCorto}`}</option>
      ))}
    </select>
  </div>
);
const SelectorRegion = ({
  idRegionSeleccionada,
  seleccionarRegion,
  regiones,
  show, handleShow, handleShowBlur, clearOptions, highlightedIndex, isSelected, clearOption
}) => (
  <div className={styles.container + " col-sm-4"}>
    <label>
      Regiones
    </label>
    <div className={styles.margenContainer}>
      <div className={styles.container2} onBlur={handleShowBlur} onClick={handleShow}>
        <label className={styles.value} htmlFor="regiones">
          {idRegionSeleccionada.map((i) => {
            if (idRegionSeleccionada.length > 1) {
              if (i.cutRegion !== "0") {
                return (
                  <button key={i.cutRegion} className={styles["option-badge"]} onClick={(e) => {
                    e.stopPropagation()
                    seleccionarRegion(i)
                  }}>{i.nombreCorto} <span className={styles["remove-btn"]}>&times;</span></button>
                )
              }
            } else {
              if (i.cutRegion !== "0") {
                return (
                  <button key={i.cutRegion} className={styles["option-badge"]} onClick={(e) => {
                    e.stopPropagation()
                    seleccionarRegion(i)
                  }}>{i.nombreCorto} <span className={styles["remove-btn"]}>&times;</span></button>
                )
              } else {
                return (
                  <button key={i.cutRegion} className={styles["option-badge"]}>
                    {i.nombreCorto}
                  </button>
                )
              }
            }
          })}
        </label>
        <button className={styles["clear-btn"]} onClick={clearOptions}>
          &times;
        </button>
        <div className={styles.divider}></div>
        <div className={styles.caret}></div>
        <ul className={`${styles.options} ${show ? styles.show : ''}`}>
          {regiones.map((region, index) => (
            <li
              key={region.cutRegion}
              value={region.nombreCorto}
              className={`${styles.option} 
              ${isSelected(region) ? styles.selected : ''}
              ${index == highlightedIndex ? styles.highlighted : ''}`}
              onClick={() => seleccionarRegion(region)}
            >{`${region.nombreCorto}`}</li>
          ))}
        </ul>
      </div>
    </div>
    {/*<select
      className="form-control"
      name="regiones"
      value={idRegionSeleccionada}
      onChange={seleccionarRegion}
    >
      <option value="0">Todas</option>
      {regiones.map((region) => (
        <option
          key={region.cutRegion}
          value={region.cutRegion}
        >{`${region.nombreCorto}`}</option>
      ))}
      </select>*/}
  </div>
);

DetalleProgramacionIG.propTypes = {
  regiones: PropTypes.arrayOf(PropTypes.object).isRequired,
  clientes: PropTypes.arrayOf(PropTypes.object).isRequired,
};



// WEBPACK FOOTER //
// ./frontEnd/inventarios/programacion-semanal/Detalle/DetalleProgramacionIG.jsx